export const Folder = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2208 2.96325H7.616C7.4688 2.96325 7.3184 2.90245 7.2 2.78405L5.808 1.39205C5.4816 1.06565 5.008 0.889648 4.5344 0.889648H1.7792C0.8 0.889648 0 1.68965 0 2.66565V15.1104H16V4.73925C16 3.76325 15.2 2.96325 14.2208 2.96325Z"
      fill="#0019A5"
    />
  </svg>
);
